import * as API from './apiBase';

let baseList = {
    GetEMTransAuth: 'api/EM4/GetEMTransAuth'
}

/*EM系统跳转鉴权 */
export const GetEMTransAuth = (param) => {
    return API.POST(baseList.GetEMTransAuth, {
        param
    })
};
